import styled from 'styled-components'

import Text from './Text'

/**
 * inlineテキスト
 */
const InlineText = styled(Text)`
  display: initial;
`

export default InlineText
